/**
 * @example
 *
 * ```
 * <app-button-icon icon="fa fa-home" title="Crear un nuevo cliente" onlyIcon="true"></app-button-icon>
 * ```
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppButtonIconComponent } from './button-icon.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
    ],
    exports: [
        AppButtonIconComponent,
    ],
    declarations: [
        AppButtonIconComponent,
    ],
    providers: [],
})
export class Gw3ButtonIconModule { }
